// extracted by mini-css-extract-plugin
export var flexBox = "index-module--flexBox--ejZmq";
export var flexItem = "index-module--flexItem--uxCBy";
export var platform = "index-module--platform--z4NPM";
export var second_title = "index-module--second_title--hpkOO";
export var textContainer = "index-module--textContainer--zWiKW";
export var title = "index-module--title--QgYWn";